import React, { useMemo } from 'react';
import type { BadgeProps } from '@components/atoms/badge/types';
import { ResponsiveTooltip } from '@components/organisms/tooltips/responsive-tooltip';
import { BadgeStatusEnum } from '@models/enums';
import cn from 'classnames';

import { BadgeContainer } from './styles';

export const Badge: React.FC<BadgeProps> = ({
    text,
    status = BadgeStatusEnum.PRIMARY,
    size = 'm',
    className,
    leftAddon,
    display,
    style,
    tooltip,
}) => {
    const classes = useMemo(() => {
        const classesToAdd: string[] = [];

        switch (status) {
            case BadgeStatusEnum.ERROR:
                classesToAdd.push('error');
                break;
            case BadgeStatusEnum.WARNING:
                classesToAdd.push('warning');
                break;
            case BadgeStatusEnum.SUCCESS:
                classesToAdd.push('success');
                break;
            case BadgeStatusEnum.DEFAULT:
                classesToAdd.push('default');
                break;
            case BadgeStatusEnum.INFO:
                classesToAdd.push('info');
                break;
            case BadgeStatusEnum.PRIMARY:
            default:
                classesToAdd.push('primary');
        }
        if (tooltip) {
            classesToAdd.push('tooltip');
        }

        return classesToAdd;
    }, [status, tooltip]);

    const component = (
        <BadgeContainer
            display={display}
            size={size}
            className={cn(classes, className)}
            style={style}
        >
            {leftAddon && <span className='badge-left-addon'>{leftAddon}</span>}
            <span className='badge-text'>{text}</span>
        </BadgeContainer>
    );

    if (tooltip) {
        return <ResponsiveTooltip title={tooltip}>{component}</ResponsiveTooltip>;
    }

    return component;
};
